import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type JournalistEnquiriesUser from "./JournalistEnquiriesUser";
import type JournalistEnquiryEntry from "./JournalistEnquiryEntry";
import type JournalistEnquiryRecipient from "./JournalistEnquiryRecipient";
import type JournalistEnquiryTag from "./JournalistEnquiryTag";
import type { ErrorWithResponse } from "./types";
import type User from "./User";

type Priority = "Low" | "Medium" | "High";

@Model()
class JournalistEnquiry extends ApplicationRecord {
  static jsonapiType = "journalist_enquiries";

  @Attr({ persist: false }) createdAt: string;

  @Attr() description: string;

  @Attr() endDate: string;

  @HasMany() journalistEnquiriesUsers: JournalistEnquiriesUser[];

  @HasMany() journalistEnquiryEntries: JournalistEnquiryEntry[];

  @HasMany() journalistEnquiryRecipients: JournalistEnquiryRecipient[];

  @HasMany() journalistEnquiryTags: JournalistEnquiryTag[];

  @Attr() organisationId: number;

  @Attr() priority: Priority;

  @Attr() source: string;

  @Attr() status: string;

  @Attr() title: string;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

JournalistEnquiry.afterFetch = (
  response,
  json: JSON & { message?: string }
) => {
  if (response.status === 401 && json.message === "sudo access required") {
    const error: ErrorWithResponse = new Error("sudo access required");
    error.response = Object.assign(response, { data: json });

    throw error;
  } else {
    ApplicationRecord.middlewareStack.afterFetch(response, json);
  }
};

export default JournalistEnquiry;
